export interface FetchProps {
    action: string;
    block_id?: string;
    method?: string;
    body?: null | FormData;
}

const a11Fetch = async ({action = '', block_id = '', method = 'GET', body = null}: FetchProps) => {

    const {ajax_url, current_page_id, site_url} = window.a11_localized_data;

    let data = body ? body : new FormData();
    data.append('action', action);

    if (block_id) {
        data.append('block_id', block_id);
    }

    if (current_page_id) {
        data.append('page_id', current_page_id);
    }

    const options: RequestInit = {
        method,
        body: data,
        //mode: 'no-cors',
    };

    try {
        const response = await fetch(ajax_url, options);

        const result = response.status !== 500 ? await response.json() : [];

        if (response.ok && response.status >= 200 && response.status <= 299) {
            return {statusCode: 200, result, errorMessage: ''};
        }

        if (response.status === 500) {
            return {statusCode: 500, errorMessage: 'There was a server error, please try again.'};
        }

        if (response.status === 403 || response.status === 401) {
            window.location.href = `${site_url}/logout/?reason=session-expired`;
        }

        const errorMessage = result?.data.errorMessage ?? 'There was an error, please try again.';

        return {statusCode: response.status, result, errorMessage};
    } catch (error) {
        return {statusCode: 500, errorMessage: error};
    }
};

export {
    a11Fetch,
};

export interface A11SiteDataModel {
    ajax_url: string,
    current_page_id: string,
    is_in_wp_admin: boolean,
    site_url: string,
}

declare global {
    interface Window {
        a11_localized_data: A11SiteDataModel
    }
}
